import { render } from "./UpdateElementGroupForm.vue?vue&type=template&id=bd3d6d6e"
import script from "./UpdateElementGroupForm.vue?vue&type=script&lang=js"
export * from "./UpdateElementGroupForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__